import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, COLLECTION, NUMBER, ITEM, INTEGER, STRING, UUID } from '@/plugins/sdk/fields'
import CrmAcType from '@/plugins/sdk/resources/Dictionary/CrmAcType'
import Portfolio from '@/plugins/sdk/resources/Dictionary/Portfolio'
import BGroup from '@/plugins/sdk/resources/Dictionary/BGroup'
import AccType from '@/plugins/sdk/resources/Dictionary/AccType'
import StationaryType from '@/plugins/sdk/resources/Dictionary/StationaryType'
import AccGrade from '@/plugins/sdk/resources/Dictionary/AccGrade'
import TradingTerm from '@/plugins/sdk/resources/Dictionary/TradingTerm'
import TimeCycle from '@/plugins/sdk/resources/Dictionary/TimeCycle'
import NotificationTemplate from '@/plugins/sdk/resources/NotificationTemplate'
import Attachment from '@/plugins/sdk/resources/Attachment'
import Asset from '@/plugins/sdk/resources/Asset'
import AssetHistory from '@/plugins/sdk/resources/Asset/History'
import Consignment from '@/plugins/sdk/resources/Consignment'
import CarrierSetting from '@/plugins/sdk/resources/Account/CarrierSetting'
import CarrierServiceSetting from '@/plugins/sdk/resources/Account/CarrierServiceSetting'
import Lead from '@/plugins/sdk/resources/Account/Lead'
import AccountEvent from '@/plugins/sdk/resources/Account/Event'
import Profile from '@/plugins/sdk/resources/Profile'
import Team from '@/plugins/sdk/resources/Team'
import Webhook from '@/plugins/sdk/resources/Account/Webhook'
import CloudPrintSettings from '@/plugins/sdk/resources/Account/CloudPrintSettings'
import CostCentre from '@/plugins/sdk/resources/Account/CostCentre'

export default class extends Resource {
  static name = 'account'
  static label = 'name'

  static get fields () {
    return {
      id: new UUID(),
      reference: new STRING(),
      name: new STRING(),
      address: new STRING(),
      suburb: new STRING(),
      state: new STRING(),
      postcode: new STRING(),
      contact: new STRING(),
      phone: new STRING(),
      fax: new STRING(),
      email: new STRING(),
      updated_at: new DATETIME(),
      next_contact: new DATETIME(),
      active: new BOOLEAN(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      can_sms: new BOOLEAN(),
      can_send_webhook_events: new BOOLEAN(),
      status: new STRING(),
      crm_portfolio_id: new INTEGER(),
      crm_account_type: new INTEGER(),
      crm_account_grade: new INTEGER(),
      crm_endangered: new INTEGER(),
      crm_msg_times: new INTEGER(),
      crm_contact_weeks: new INTEGER(),
      crm_stationary: new INTEGER(),
      billing_qbname: new STRING(),
      billing_myob_id: new NUMBER(),
      billing_billparent: new BOOLEAN(),
      billing_onholdcount: new INTEGER(),
      billing_onhold: new BOOLEAN(),
      billing_abn: new STRING(),
      billing_acn: new STRING(),
      billing_invoice_minval: new NUMBER(),
      billing_invoice_reqrecon: new BOOLEAN(),
      billing_active: new BOOLEAN(),
      billing_terms_days: new INTEGER(),
      shipper_manifest_type: new INTEGER(),
      shipper_channel: new INTEGER(),
      shipper_polling_active: new BOOLEAN(),
      shipper_polling_folder: new STRING(),
      shipper_polling_filename: new STRING(),
      shipper_dg_emergcont: new STRING(),
      shipper_dg_emergphone: new STRING(),
      shipper_cost_warning: new INTEGER(),
      shipper_closing_time: new DATETIME(),
      shipper_auonly: new BOOLEAN(),
      shipper_enable_plus: new BOOLEAN(),
      shipper_ceil_weights: new INTEGER(),
      shipper_active: new BOOLEAN(),
      shipper_api_key: new STRING(),
      tmp_image: new STRING(),
      tmp_image_mobile: new STRING(),
      tmp_image_tablet: new STRING(),
      tmp_button: new STRING(),
      tmp_banner: new STRING(),
      tmp_link: new STRING(),
      tmp_analytics_id: new STRING(),
      background_colour: new STRING(),
      tracking_heading: new STRING(),
      tracking_theme: new STRING(),
      date_created: new DATETIME(),
      date_started: new DATETIME(),
      date_closed: new DATETIME(),
      date_reopened: new DATETIME(),
      date_lasttraded: new DATETIME(),
      acc_type: new ITEM(AccType),
      assets: new COLLECTION(Asset),
      asset_histories: new COLLECTION(AssetHistory),
      b_group: new ITEM(BGroup),
      consignment: new ITEM(Consignment),
      carrier_settings: new COLLECTION(CarrierSetting),
      carrier_service_settings: new COLLECTION(CarrierServiceSetting),
      crm_ac_type: new ITEM(CrmAcType),
      portfolio: new ITEM(Portfolio),
      account_manager: new ITEM(Profile),
      parent: new ITEM(this),
      children: new COLLECTION(this),
      stationary_type: new ITEM(StationaryType),
      acc_grade: new ITEM(AccGrade),
      trading_term: new ITEM(TradingTerm),
      time_cycle: new ITEM(TimeCycle),
      notification_templates: new COLLECTION(NotificationTemplate),
      tracking_logo: new ITEM(Attachment),
      tracking_background: new ITEM(Attachment),
      tracking_logo_link: new STRING(),
      tracking_logo_position: new STRING(),
      lead: new ITEM(Lead),
      investigator: new ITEM(Profile),
      advisor: new ITEM(Profile),
      leads: new COLLECTION(Lead),
      events: new COLLECTION(AccountEvent),
      teams: new COLLECTION(Team),
      daily_download: new BOOLEAN(),
      monitor_tracking: new BOOLEAN(),
      shipper_fill_missing_receiver_address_fields: new BOOLEAN(),
      webhooks: new COLLECTION(Webhook),
      information: new STRING(),
      sso_code: new STRING(),
      sso_status: new NUMBER(),
      slug: new STRING(),
      freshdesk_object_id: new STRING(),
      cloud_print_settings: new ITEM(CloudPrintSettings),
      cost_centres: new COLLECTION(CostCentre),
      is_parent: new BOOLEAN(),
      is_child: new BOOLEAN(),
      is_open360: new BOOLEAN()
    }
  }

  static get sortables () {
    return [
      { field: 'name', label: 'Name' },
      { field: 'updated_at', label: 'Last Updated' },
      { field: 'created_at', label: 'Date Created' },
      { field: 'account_id', label: 'Billing Code' }
    ]
  }
}
